import { render, staticRenderFns } from "./qualityDetail.vue?vue&type=template&id=1322049e&scoped=true&"
import script from "./qualityDetail.vue?vue&type=script&lang=js&"
export * from "./qualityDetail.vue?vue&type=script&lang=js&"
import style0 from "./qualityDetail.vue?vue&type=style&index=0&id=1322049e&lang=scss&scoped=true&"
import style1 from "./qualityDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322049e",
  null
  
)

export default component.exports